export default __webpack_public_path__ + "static/media/logo-vertical-colored.426b6395.svg";